import { Container } from "reactstrap";

export const HowMany = () => (
  <Container className="center mt-3">
      <h1>How Many</h1>
  </Container>
);
